import { formatPerson, formatPersonList } from "@shared/lib/format-person";
import type { MockRecordRow } from "./mock-data";
import type { ActsRegistryItemDto } from "./types";
import { getWorkTypeLabel } from "./work-types";

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "-";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}

function formatClosing(item: ActsRegistryItemDto): string {
  if (item.closingName) return item.closingName;
  if (!item.closingCreationDate && !item.closingStartDate) return "-";
  const created = item.closingCreationDate
    ? formatDate(item.closingCreationDate.split("T")[0])
    : "";
  const from = formatDate(item.closingStartDate);
  const to = formatDate(item.closingEndDate);
  return `Закрытие от ${created} за период: ${from} - ${to}`;
}

function formatKs2(item: ActsRegistryItemDto): string {
  if (!item.actKsItemDtoList?.length) return "-";
  return (
    item.actKsItemDtoList
      .map((k) => k.code ?? k.name ?? "")
      .filter(Boolean)
      .join(", ") || "-"
  );
}

export function mapDtoToRow(dto: ActsRegistryItemDto): MockRecordRow {
  return {
    key: dto.actId,
    fullName: dto.fullName ?? "-",
    actDate: formatDate(dto.actDate),
    workName: dto.currentWork ?? "-",
    workType: getWorkTypeLabel(dto.workType),
    approvalStatus: dto.approvalStatus ?? "",
    notes: "-",
    closing: formatClosing(dto),
    creatorName: formatPerson(dto.creatorName),
    assigneeNames: formatPersonList(dto.assigneeNames),
    inspectorNames: formatPersonList(dto.inspectorNames),
    sectionName: dto.sectionName ?? "-",
    currentWork: dto.currentWork ?? "-",
    contract: "-",
    ks2: formatKs2(dto),
  };
}
